import { BrowserContext } from "../contexts/BrowserContext"
import Card from "./Card";
import { menu } from "./menu";

let sidebarSelected, sidebarSearchInput = '', searchTerms = [];

const Canvas = () => {

    return (
        <BrowserContext.Consumer>
        {({browserContextData}) => {
            
            if ('menu' in browserContextData)
            menu = browserContextData['menu']

            if ('sidebarSelected' in browserContextData)
            sidebarSelected = browserContextData['sidebarSelected']

            return (
                <div className="canvas" id="canvas">
                    {/* <p>{browserContextData['sidebarSelected']}</p> */}
                    {/* {console.log("BROWSER CONTEXT MENU", browserContextData['menu'])} */}

                    {
                        (sidebarSelected === '' || sidebarSelected.toLowerCase() === 'all menu') 
                        ?
                        menu.map(item => (
                            <Card data={item}></Card>
                        )) 
                        :
                        (
                            (sidebarSelected === 'sidebarSearch') 
                            ?
                            menu
                            .filter(item => {

                                if ('sidebarSearchInput' in browserContextData)
                                sidebarSearchInput = browserContextData['sidebarSearchInput']

                                if ('searchTerms' in browserContextData)
                                searchTerms = browserContextData['searchTerms']

                                var searchPhrase = sidebarSearchInput.toLowerCase()

                                var nameContainsSearchTerm = false
                                var tagsContainsSearchTerm = false

                                searchTerms.forEach(s => {

                                    if (item['name'].toLowerCase().includes(s.toLowerCase())) 
                                        nameContainsSearchTerm = true

                                    if (item['tags'].includes(s.toLowerCase()) ||
                                        item['tags'].join(' ').includes(s.toLowerCase()))
                                        tagsContainsSearchTerm = true
                                })
                                

                                return (
                                    // tags are already lowercased 
                                    item['tags'].includes(searchPhrase) || 
                                    item['tags'].includes(searchPhrase + 's') ||
                                    item['tags'].join(' ').includes(searchPhrase) ||
                                    item['name'].toLowerCase().includes(searchPhrase) ||
                                    item['price'].toString().includes(searchPhrase) ||

                                    searchTerms.includes(item['name'].toLowerCase()) ||
                                    searchTerms.includes(item['price'].toString()) ||

                                    nameContainsSearchTerm ||
                                    tagsContainsSearchTerm
                                    // improve search within new properties here
                                ) ? true : false
                            })
                            .sort((a, b) => (a['name'] > b['name']))
                            .map(item => (
                                <Card data={item}></Card>
                            ))
                            :
                            menu
                            .filter(item => {

                                var searchPhrase = sidebarSelected.toLowerCase()
                                
                                return (
                                    item['tags'].includes(searchPhrase) || 
                                    item['tags'].includes(searchPhrase + 's')
                                ) ? true : false
                            })
                            .map(item => (
                                <Card data={item}></Card>
                            ))
                        )
                    }
        
                </div>
            )
        }}
        </BrowserContext.Consumer>
    )
}

export default Canvas